import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "../../ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import React from "react";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import {
  bookkeepingStatusOptions,
  FILTER_BOOKKEEPING_STATUS,
} from "../Task1120FilterOptions";

export const BookkeepingStatusColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
}) => {
  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>Bookkeeping Status</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_BOOKKEEPING_STATUS}
        options={bookkeepingStatusOptions}
        selected={values.BOOKKEEPING_STATUS || null}
        updateFilter={updateFilter}
      />
    </div>
  );
};
